import { ListCollection, filePathToTree, TreeCollection } from '@zag-js/collection';

const createListCollection = (options) => new ListCollection(options);
const createTreeCollection = (options) => new TreeCollection(options);
const createFileTreeCollection = (paths) => filePathToTree(paths);

export { createFileTreeCollection, createListCollection, createTreeCollection };
